import { Component, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-tooltip',
  templateUrl: './tooltip.component.html',
  styleUrls: [ './tooltip.component.scss' ]
})
export class TooltipComponent {
  @Input() public text: string;
  @Input() public content: TemplateRef<any>;
  @Input() public position: string = 'top';
}